<section class="rms-error" [class.rms-error--critical]="kind === 'error'">
  <header class="rms-error__hero">
    <div class="rms-error__topline">
      <span class="rms-error__brand"><span class="rms-error__brand-mark">R</span> RMS</span>
      @if (dismissible) {
        <button type="button" class="rms-error__close" aria-label="Close alert" (click)="close()">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            aria-hidden="true"
          >
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      }
    </div>

    <div class="rms-error__symbol" aria-hidden="true">
      @switch (kind) {
        @case ('connection') {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M2 9a16 16 0 0 1 17-2M5 12a11 11 0 0 1 10-2M8.5 15a6 6 0 0 1 3.5-1" />
            <path d="m3 3 18 18" />
            <path d="M12 20h.01" />
          </svg>
        }
        @case ('access') {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="5" y="10" width="14" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
          </svg>
        }
        @default {
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M10.3 3.9 1.9 18.4A1.8 1.8 0 0 0 3.5 21h17a1.8 1.8 0 0 0 1.6-2.6L13.7 3.9a1.9 1.9 0 0 0-3.4 0Z"
            />
            <path d="M12 9v5M12 17.5h.01" />
          </svg>
        }
      }
    </div>

    <p class="rms-error__eyebrow">{{ label }}</p>
    <h2 class="rms-error__title" id="rms-error-title">{{ title }}</h2>
    <p class="rms-error__subtitle">
      @if (kind === 'session') {
        Your account is protected. Sign in to continue your work.
      } @else if (kind === 'connection') {
        We couldn't complete the request right now.
      } @else if (kind === 'access') {
        You don't have permission to access this workspace.
      } @else {
        We couldn't complete this action.
      }
    </p>
  </header>

  <div class="rms-error__content">
    <div class="rms-error__message">
      <span class="rms-error__message-icon" aria-hidden="true">i</span>
      <p>{{ message }}</p>
    </div>

    <div class="rms-error__bottom">
      <span class="rms-error__code">
        @if (status !== undefined) {
          ERROR CODE · {{ status }}
        } @else {
          RMS · NOTIFICATION
        }
      </span>
      <button type="button" class="rms-error__action" (click)="close()" autofocus>
        <span>{{ actionLabel }}</span>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12h14m-6-6 6 6-6 6" />
        </svg>
      </button>
    </div>
  </div>
</section>
